<template>
   <v-container class="pt-1 pb-12 py-sm-12">
        <v-row class="d-none d-sm-flex">
            <v-col :cols="12">
                  <div class="title-container d-flex justify-space-between align-center">
                  <div class="title-block">
    <div class="d-flex align-center ga-3">
      <span class="page-title">{{ page.title }}</span>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="primary" text v-bind="attrs" v-on="on">  
  <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
</v-btn>
                          </template>
                          <v-card min-width="380px">
                            <v-card-title class="text-h6 font-weight-bold pb-2">
                              <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pt-3 pb-3">
                              <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🏷️ Nome</p><p class="text-caption grey--text">Apelido curto da máquina, até 4 letras. Ex: LAV1</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">🖥️ Tipo de máquina</p><p class="text-caption grey--text">Se é uma lavadora ou secadora</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">⏱️ Tempo de bloqueio</p><p class="text-caption grey--text">Quantidade de minutos que a maquina fica "Ocupada" após o pagamento.</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor</p><p class="text-caption grey--text">Quanto o cliente paga para usar essa máquina</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Posição</p><p class="text-caption grey--text">Ordem em que aparece no totem. Número menor aparece primeiro</p></div>
<v-divider class="my-2"></v-divider>
<div><p class="font-weight-bold text-caption mb-1">✅ Status</p><p class="text-caption grey--text">Habilitada = aceitando uso. Desabilitada = fora de serviço</p></div>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                  </div>
                   <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                </div>
                <div class="button-group">
  <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/maquinas">Voltar</v-btn>
    <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
        :loading="dataset.loading">Salvar</v-btn>
</div>
              </div>
            </v-col>
        </v-row>

      <v-row class="d-sm-none d-lg-none d-md-flex">
    <v-col :cols="12">
        <div class="title-container">
           <div class="title-block">
              <div class="d-flex align-center">
    <span class="page-title">{{ page.title }}</span>
    <v-btn icon small color="primary" class="ml-2" @click="dialogAjudaMobile = true">
        <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>
</div>
    <v-breadcrumbs class="app-breadcrumb" divider="›"
        :items="dataset.breadcrumbItems"></v-breadcrumbs>
</div>
        </div>
    </v-col>
</v-row>
        <v-row class="d-sm-none d-lg-none d-md-flex">
            <v-col>
                <div class="button-group">
   <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/maquinas">Voltar</v-btn>
    <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
        :loading="dataset.loading">Salvar</v-btn>
</div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field dense label="Nome" v-model="dataset.data.nome" required
                                                :rules="[$rules.required, $rules.maxlength(dataset.data.nome, 4)]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                       <v-col cols="12" sm="6" class="pb-3">
                                            <v-select dense :items="dataset.machineTypes" label="Tipo de máquina"
                                                v-model="dataset.data.tipo" item-value="id" item-text="name" outlined
                                                :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4" class="pb-3">
                                            <v-text-field dense type="number" label="Tempo de bloqueio"
                                                v-model="dataset.data.tempoBloqueioMaquina" required outlined
                                                hide-details="auto" :rules="[$rules.required]" suffix="minuto(s)">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" class="pb-3">
                                            <v-currency-field label="Valor" dense v-model="dataset.data.valor"
                                                prefix="R$" :allowNegative=false hide-details="auto" outlined required
                                                :rules="[$rules.required]">
                                            </v-currency-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" class="pb-3">
                                            <v-text-field dense type="number" label="Posição"
                                                v-model="dataset.data.posicao" required outlined hide-details="auto"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-select disabled dense :items="dataset.upboxes" label="Upbox"
                                                v-model="dataset.data.upboxId" item-value="id" item-text="identificador"
                                                outlined :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-select dense :items="dataset.machineStatus" label="Status"
                                                v-model="dataset.data.habilitada" item-value="value" item-text="name"
                                                outlined :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field readonly disabled dense type="number" label="Ciclos"
                                                v-model="dataset.data.contadorCiclos" required outlined
                                                hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field readonly disabled dense type="number" label="Ciclos (Parcial)"
                                                v-model="dataset.data.contadorParcialCiclos" required outlined
                                                hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row> -->
                                </v-card-text>

                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Informações</v-card-title>
                                <v-card-text>
                                    <span>
                                        <strong>
                                            Ciclos:
                                        </strong>
                                        {{ dataset.data.contadorCiclos }}
                                    </span>
                                    <br>
                                    <span class="mt-4">
                                        <strong>
                                            Ciclos (Parcial):
                                        </strong>
                                        {{ dataset.data.contadorParcialCiclos }}
                                    </span>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-card :disabled="dataset.loading" class="card-form-outlined">
                                <v-card-title class="card-group-title">Ações</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                        <v-btn class="mr-3 mt-2" type="button" elevation="0" style="background-color: #f44336 !important; color: white !important;" dark @click="sendPulse">Enviar Pulso</v-btn>
<v-btn class="mr-3 mt-2" type="button" elevation="0" outlined style="color: #f44336 !important; border-color: #f44336 !important;" @click="resetCycles">Resetar contador</v-btn>
<v-btn class="mt-2" type="button" elevation="0" style="background-color: #f44336 !important; color: white !important;" dark @click="releaseMachine">Liberar Máquina</v-btn>
                                        </v-col>
                                        <!-- <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.machineTypes" label="Tipo de máquina"
                                                v-model="dataset.data.tipo" item-value="id" item-text="name" outlined
                                                :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col> -->
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
       <div class="popup-mobile-header">
    <span class="popup-mobile-header-title">
        <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
    </span>
    <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
        <v-icon size="18">mdi-close</v-icon>
    </v-btn>
</div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🏷️ Nome</p><p class="text-caption grey--text">Apelido curto da máquina, até 4 letras. Ex: LAV1</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🖥️ Tipo de máquina</p><p class="text-caption grey--text">Se é uma lavadora ou secadora</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">⏱️ Tempo de bloqueio</p><p class="text-caption grey--text">Quantidade de minutos que a maquina fica "Ocupada" após o pagamento.</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor</p><p class="text-caption grey--text">Quanto o cliente paga para usar essa máquina</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">✅ Status</p><p class="text-caption grey--text">Habilitada = aceitando uso. Desabilitada = fora de serviço</p></div>
        </v-card-text>
    </v-card>
</v-dialog>
    </v-container>
</template>

<script>
import string from "@/common/util/string"
import object from "@/common/util/object"

import machineTypes from "@/common/data/machine-types.data"
import machineStatus from "@/common/data/machine-status.data"

import axios from "axios"
import { eventHub } from "@/main"

export default {
    name: "MachineDetails",

  data: () => ({
        page: {
            title: "",
        },
        dialogAjudaMobile: false,
        dataset: {
            breadcrumbItems: [],
            upboxes: [],
            machineTypes: machineTypes,
            machineStatus: machineStatus,
            data: {},
            loading: false,
        },
        dataForm: {
            validForm: true,
            updateLoading: false,
            removeLoading: false,
        },
    }),

    mounted() {
  eventHub.$on('CHANGE-OPERATION', () => {
    this.$router.push('/maquinas');
  });
  this.loadData();
},
destroyed() {
  eventHub.$off('CHANGE-OPERATION');
},

    methods: {
        goBack() {
            this.$router.replace("/maquinas");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
            await this.loadUpbox();
        },

        setPage() {
            this.page.title = `Detalhes da máquina`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de máquinas",
                disabled: false,
                to: "/maquinas",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes da máquina`,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            this.dataset.loading = true

            console.log('load ');

            try {
                const result = await axios.get(`/api/maquina/${this.$route.params.id}`);

                this.dataset.data = result.data
                this.dataset.data.upboxId = this.dataset.data.upbox.id;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadUpbox() {
            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/upbox`);

                this.dataset.upboxes = result.data
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }
        },

                async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar a máquina <strong>${this.dataset.data.nome}</strong>?`,
                title: 'Atualizar máquina',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.put(`/api/maquina/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Máquina salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async releaseMachine() {

            if (!this.$refs.form.validate()) return;

                      const proceedAction = await this.$dialog.confirm({
                text: `Deseja liberar a máquina <strong>${this.dataset.data.nome}</strong> do tempo de bloqueio?`,
                title: 'Liberar máquina',
                actions: {
                    false: 'Cancelar',
                    true: { text: 'Liberar', color: 'primary' }
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.post(`/api/maquina/${this.$route.params.id}/liberar-bloqueio-tempo`, {});

                this.$dialog.notify.info("Liberação enviada com sucesso", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

           async sendPulse() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar o pulso para a máquina <strong>${this.dataset.data.nome}</strong>?`,
                title: 'Pulso',
                actions: {
                    false: 'Cancelar',
                    true: { text: 'Enviar', color: 'primary' }
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.post(`/api/maquina/${this.$route.params.id}/enviar-pulso`, {});

                this.$dialog.notify.info("Pulso enviado com sucesso", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async resetCycles() {

            if (!this.$refs.form.validate()) return;

                        const proceedAction = await this.$dialog.confirm({
                text: `Deseja resetar o contador parcial da máquina <strong>${this.dataset.data.nome}</strong>?`,
                title: 'Contador',
                actions: {
                    false: 'Cancelar',
                    true: { text: 'Resetar', color: 'primary' }
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.post(`/api/maquina/${this.$route.params.id}/reset-contador-parcial`, {});

                this.$dialog.notify.info("Contador resetado com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {
            const data = {
                nome: this.dataset.data.nome,
                tipo: this.dataset.data.tipo,
                tempoBloqueioMaquina: this.dataset.data.tempoBloqueioMaquina,
                valor: this.dataset.data.valor,
                posicao: this.dataset.data.posicao,
                upboxId: this.dataset.data.upboxId,
                habilitada: this.dataset.data.habilitada
            }

            return data;
        },




    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-size: 14px;
    font-style: normal;
}
.ga-3 { gap: 24px; }

/* O QUE FOI ADICIONADO: Ajuste exclusivo para os botões no Mobile */
@media (max-width: 768px) {
  .button-group {
    display: flex !important;
    width: 100% !important;
    gap: 12px !important;
    margin-top: 8px !important;
    margin-bottom: 16px !important;
  }

  .button-group .v-btn {
    flex: 1 !important;
    min-width: unset !important;
  }
}
</style>